class Recommendation {
    static id = 'id';
    static petname = 'name';
    static description = 'description';
    static age = 'age';
    static image = 'image';
    static sex = 'sex';
    static size = 'size';
    static type = 'type';

    // TODO: Pasarlo a un metodo toObject, para retornar un objecto
}

export default Recommendation;